import React from 'react';
import { Container, Typography, Box, Grid, Paper, Divider } from '@mui/material';
import { Groups, Lightbulb, TrendingUp, Verified } from '@mui/icons-material';
import bannerImg from '../images/bannerImg.png';

const AboutUs = () => {
  return (
    <Box sx={{ bgcolor: '#fdfdfd' }}>
      {/* Header Section */}
      <Box sx={{ bgcolor: 'primary.main', color: 'white', py: 10, textAlign: 'center' }}>
        <Container maxWidth="md">
          <Typography variant="h2" component="h1" gutterBottom fontWeight="bold">
            About Thathva Industries
          </Typography>
          <Typography variant="h5" sx={{ opacity: 0.9 }}>
            Crafting Excellence in Every Thread Since Our Inception.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 10 }}>
        {/* Company Overview */}
        <Grid container spacing={8} alignItems="center" sx={{ mb: 10 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom fontWeight="bold" color="primary">
              Our Story
            </Typography>
            <Typography variant="body1" paragraph sx={{ fontSize: '1.1rem', color: 'text.secondary' }}>
              Thathva Industries is a premier uniform manufacturing company dedicated to providing high-quality attire for educational institutions and corporate organizations. With a focus on durability, comfort, and style, we have established ourselves as a trusted partner for some of the region's leading schools.
            </Typography>
            <Typography variant="body1" sx={{ fontSize: '1.1rem', color: 'text.secondary' }}>
              Our name, "Thathva," represents the essence or principle of truth and quality. This philosophy drives everything we do, from sourcing the finest fabrics to employing skilled artisans who take pride in their work.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={3} sx={{ p: 1, borderRadius: 4 }}>
              <Box 
                component="img"
                src={bannerImg}
                alt="Our Workshop"
                sx={{ width: '100%', borderRadius: 3, display: 'block' }}
              />
            </Paper>
          </Grid>
        </Grid>

        <Divider sx={{ mb: 10 }} />

        {/* Mission & Vision */}
        <Grid container spacing={4} sx={{ mb: 10 }}>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 5, height: '100%', borderRadius: 4, bgcolor: '#f8f9fa', borderLeft: '6px solid', borderColor: 'primary.main' }}>
              <Lightbulb color="primary" sx={{ fontSize: 40, mb: 2 }} />
              <Typography variant="h4" gutterBottom fontWeight="bold">
                Our Mission
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
                To empower students by providing uniforms that foster a sense of belonging and pride, while ensuring maximum comfort for their daily learning journey. We aim to simplify the uniform procurement process for parents through innovation and technology.
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper sx={{ p: 5, height: '100%', borderRadius: 4, bgcolor: '#f8f9fa', borderLeft: '6px solid', borderColor: 'secondary.main' }}>
              <TrendingUp color="secondary" sx={{ fontSize: 40, mb: 2 }} />
              <Typography variant="h4" gutterBottom fontWeight="bold">
                Our Vision
              </Typography>
              <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.1rem' }}>
                To be the leading uniform solutions provider in India, recognized for our commitment to quality, sustainability, and exceptional customer service. We envision a future where every student feels confident and comfortable in their school attire.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Values Section */}
        <Box sx={{ textAlign: 'center', mb: 10 }}>
          <Typography variant="h3" gutterBottom fontWeight="bold" sx={{ mb: 6 }}>
            Our Core Values
          </Typography>
          <Grid container spacing={4}>
            {[
              { icon: <Verified color="primary" />, title: "Quality First", desc: "We never compromise on the quality of our materials or craftsmanship." },
              { icon: <Groups color="primary" />, title: "Customer Centric", desc: "Everything we do is designed to provide the best experience for parents and schools." },
              { icon: <Verified color="primary" />, title: "Integrity", desc: "We maintain transparency and honesty in all our business dealings." }
            ].map((value, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Box sx={{ p: 2 }}>
                  <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
                    {React.cloneElement(value.icon, { sx: { fontSize: 50 } })}
                  </Box>
                  <Typography variant="h5" gutterBottom fontWeight="bold">
                    {value.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {value.desc}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>

        {/* Legal Info */}
        <Paper elevation={0} sx={{ p: 4, bgcolor: '#f0f4f8', borderRadius: 4, textAlign: 'center' }}>
          <Typography variant="h6" color="primary" gutterBottom>
            Legal Information
          </Typography>
          <Typography variant="body1">
            <strong>Legal Name:</strong> Thathva Industries
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
            Registered and operating in compliance with Indian industrial standards.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default AboutUs;
